import React from "react";
import { motion } from 'framer-motion';
import Navbar from "./Sections/Navbar";
import AboutSection from "./Sections/AboutSection";
import RecognitionsSection from "./Sections/RecognitionsSection";

const pageVariants = {
  initial: {
    opacity: 0,
    y: "100vh",
  },
  in: {
    opacity: 1,
    y: 0,
  },
  out: {
    opacity: 0,
    y: "-100vh",
  },
};

const pageTransition = {
  type: "tween",
  ease: "anticipate",
  duration: 1.0,
};

const AboutPage = () => {
  return (
    <motion.div
      initial="initial"
      animate="in"
      exit="out"
      variants={pageVariants}
      transition={pageTransition}
      style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}
    >
      <Navbar />
      <div style={{ paddingTop: "120px", flex: 1 }}>
        <AboutSection />
        <RecognitionsSection />
      </div>
    </motion.div>
  );
};

export default AboutPage;
